module.exports = __webpack_public_path__ + "img/phone.8d05b01b.svg";